import React, { useEffect, useState } from 'react'
import FetchApi from '../customhooks/functionFetchApi'
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Badge from 'react-bootstrap/Badge';
import DataTable from 'react-data-table-component';
import { AiOutlineFileSearch } from "react-icons/ai";
import { BsExclamationCircleFill, BsClockHistory, BsCheckCircleFill, BsFileEarmarkText, BsPeopleFill } from "react-icons/bs";
import { MdPendingActions } from "react-icons/md";
import BarChart from './BarChart';
import PieChart from './PieChart';


const columns = [
  {
    name: 'TDS Code',
    sortable: true,
    grow: 0.7,
    selector: row => (
      <div style={{ padding: '4px 0' }}>
        <div style={{ fontWeight: 600, color: '#2c3e50' }}>{row.tdscode}</div>
        <div style={{ fontSize: 11, color: '#7f8c8d' }}>v.{row.revision}</div>
        {row.salerunnumber !== "" && (
          <div style={{ fontSize: 11, color: '#95a5a6' }}>({row.salerunnumber})</div>
        )}
      </div>
    ),
  },
  {
    name: 'วันที่สร้าง',
    grow: 0.5,
    selector: row => <span style={{ fontSize: 12, color: '#555' }}>{row.createdate}</span>,
  },
  {
    name: 'ประเภท',
    grow: 1,
    selector: row => (
      <Badge bg="info" style={{ fontSize: 11, fontWeight: 400, whiteSpace: 'normal', textAlign: 'left' }}>
        {row.journaltype}
      </Badge>
    ),
  },
  {
    name: 'ลูกค้า / สินค้า',
    grow: 1.2,
    selector: row => (
      <div style={{ padding: '4px 0', fontSize: 12 }}>
        <div><span style={{ color: '#95a5a6' }}>ลูกค้า:</span> {row.customername}</div>
        <div><span style={{ color: '#95a5a6' }}>สินค้า:</span> {row.productname}</div>
      </div>
    ),
  },
  {
    name: 'ผู้สร้างเอกสาร',
    grow: 0.6,
    selector: row => <span style={{ fontSize: 12 }}>{row.createby}</span>,
  },
  {
    name: 'สถานะ',
    grow: 0.6,
    selector: row => (
      <Badge bg="warning" text="dark" style={{ fontSize: 11 }}>{row.statusflow=='1003' ? 'รอรับเอกสาร' : 'สถานะอื่น'}</Badge>
    ),
  },
  {
    name: 'ลำดับอนุมัติ',
    grow: 0.5,
    selector: row => (
      <Badge bg="secondary" style={{ fontSize: 11 }}>
        ลำดับที่ {row.stateflow}
      </Badge>
    ),
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
      backgroundColor: '#2980b9',
      borderRadius: '6px 6px 0 0',
    },
  },
  headCells: {
    style: {
      color: '#fff',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: '#eaf4fb',
      borderBottomColor: '#d5eaf6',
      borderRadius: '4px',
      outline: '1px solid #d5eaf6',
    },
  },
  pagination: {
    style: { border: 'none' },
  },
};


function ShowDetailJournalById({ Id }) {
  const FetchApis = new FetchApi()
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [datalist, setDatalist] = useState([])

  function handleShow() {
    DetaillistById(Id)
    setFullscreen(true);
    setShow(true);
  }

  function DetaillistById(Id) {
    FetchApis.FethcGet(`/reportjournal/getjournalPrerecievbyId/${Id}`).then((res) => {
      if (res) {
        setDatalist(res.data.data)
      }
    })
  }

  return (
    <>
      <Button
        size='sm'
        variant="outline-primary"
        onClick={handleShow}
        style={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 4 }}
      >
        <AiOutlineFileSearch size={14} /> ดูข้อมูล
      </Button>

      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton style={{ backgroundColor: '#2980b9', color: '#fff' }}>
          <Modal.Title style={{ fontSize: 16 }}>
            <BsFileEarmarkText style={{ marginRight: 8 }} />
            รายการเอกสาร รอรับเอกสาร
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 20 }}>
          {datalist.length > 0
            ? <DataTable
                columns={columns}
                data={datalist}
                pagination
                customStyles={customStyles}
                highlightOnHover
              />
            : (
              <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
                <BsFileEarmarkText size={40} />
                <div style={{ marginTop: 8 }}>ไม่พบข้อมูล</div>
              </div>
            )
          }
        </Modal.Body>
      </Modal>
    </>
  )
}


const SectionHeader = ({ icon, title, color }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 16px',
    backgroundColor: color,
    borderRadius: '8px 8px 0 0',
    color: '#fff',
    fontWeight: 600,
    fontSize: 14,
  }}>
    {icon}
    {title}
  </div>
);


const Reportstatusjournalall = () => {
  const FetcApis = new FetchApi()
  const [dataprestatus, setDataprestatus] = useState([]);
  const [datarecievstatus, setDatarecievstatus] = useState([])
  const [reloading, setReloading] = useState(false)

  const [dataJournalPrint, setDataJournalPrint] = useState([])
  const [dataJournalNotPrint, setDataJournalNotPrint] = useState([])
  const [dataJourReviewList, setDataJourReviewList] = useState([])
  const [datapie, setDataPie] = useState([])

  const [namedapartlist, setNamedapartlist] = useState("")
  const [totallist, setTotallist] = useState([])


  useEffect(() => {
    setReloading(true)
    getapistatusall()
    getlistdatastep()
    getdatachartlist()
  }, [])

  function getapistatusall() {
    FetcApis.FethcGet(`/reportjournal/getstautsjournalall`).then((res) => {
      if (res) {
        setDataprestatus(res.data.data.dataprereciev[0])
        setDatarecievstatus(res.data.data.datareciev[0])
        setTimeout(() => setReloading(false), 700);
      }
    })
  }

  function getlistdatastep() {
    FetcApis.FethcGet(`/reportjournal/getJournalGrouptTypelist`).then((res) => {
      if (res) {
        setDataJourReviewList(res.data.data.dataListRecieve[0])
        setDataJournalPrint(res.data.data.dataListTypeJournalPrint[0])
        setDataJournalNotPrint(res.data.data.dataListTypeJournalNotPrint[0])
        setTimeout(() => setReloading(false), 700);
      }
    })
  }

  var datadapart = [], datastateflow = [], datatotal = [];

  function getdatachartlist() {
    FetcApis.FethcGet(`/reportjournal/getreportChart`).then((res) => {
      if (res) {
        var dt = res.data.data.dataPiechart[0]
        var dtc = res.data.data.databarchart[0]
        var datachart = [dt[0].totalPreReciev, dt[0].totalreciev, dt[0].totalsuccessfully]
        setDataPie(datachart)

        dtc.forEach(element => {
          datadapart.push(element.namedepart);
          datastateflow.push(element.stateflow)
          datatotal.push(element.total)
        });
        setNamedapartlist(datadapart)
        setTotallist(datatotal)

        datadapart = []; datastateflow = []; datatotal = []
      }
    })
  }

  const pendingCount = dataprestatus.length > 0
    ? dataprestatus.reduce((sum, item) => sum + (parseInt(item.total) || 0), 0)
    : 0;
  const urgentCount = dataprestatus.length > 0
    ? dataprestatus.filter(item => parseInt(item.total) > 5).length
    : 0;

  return (
    <div style={{ padding: '16px', backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
      {reloading ? (
        <div className='body-center-page'>
          <Spinner animation="grow" variant="success" role="status" />
          <span style={{ marginLeft: 10, color: '#555' }}>กำลังโหลดข้อมูล...</span>
        </div>
      ) : (
        <div style={{ maxWidth: '100%' }}>

          {/* Summary Stats */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
            <div style={statCardStyle('#e74c3c', '#fff')}>
              <MdPendingActions size={28} />
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{pendingCount}</div>
                <div style={{ fontSize: 12, opacity: 0.85 }}>รอรับเอกสาร</div>
              </div>
            </div>
            <div style={statCardStyle('#e67e22', '#fff')}>
              <BsExclamationCircleFill size={24} />
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{urgentCount}</div>
                <div style={{ fontSize: 12, opacity: 0.85 }}>ผู้อนุมัติที่มีเอกสาร &gt;5</div>
              </div>
            </div>
            <div style={statCardStyle('#2980b9', '#fff')}>
              <BsClockHistory size={24} />
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{dataJourReviewList.length}</div>
                <div style={{ fontSize: 12, opacity: 0.85 }}>กำลังดำเนินการ</div>
              </div>
            </div>
            <div style={statCardStyle('#27ae60', '#fff')}>
              <BsCheckCircleFill size={24} />
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{datapie[2] || 0}</div>
                <div style={{ fontSize: 12, opacity: 0.85 }}>เอกสารเสร็จแล้ว</div>
              </div>
            </div>
          </div>

          {/* Charts */}
          <Card style={{ marginBottom: 20, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 10 }}>
            <Card.Body>
              <div style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ flex: 2, minWidth: 280, height: 280 }}>
                  {namedapartlist !== "" && (
                    <BarChart namedapartlist={namedapartlist} Totallist={totallist} />
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 220, height: 260, display: 'flex', justifyContent: 'center' }}>
                  <PieChart datapie={datapie} />
                </div>
              </div>
            </Card.Body>
          </Card>

          {/* Pending Table */}
          <Card style={{ marginBottom: 20, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 10, overflow: 'hidden' }}>
            <SectionHeader
              icon={<BsExclamationCircleFill size={16} />}
              title={`รายการรอรับเอกสาร (${dataprestatus.length} รายการ)`}
              color="#c0392b"
            />
            <Card.Body style={{ padding: 0 }}>
              <Table hover style={{ fontSize: 13, marginBottom: 0 }}>
                <thead>
                  <tr style={{ backgroundColor: '#fdf2f2' }}>
                    <th style={thStyle}>#</th>
                    <th style={thStyle}><BsPeopleFill style={{ marginRight: 5 }} />ผู้อนุมัติ</th>
                    <th style={thStyle}>แผนก</th>
                    <th style={thStyle}>ลำดับอนุมัติ</th>
                    <th style={thStyle}>สถานะ</th>
                    <th style={thStyle}>จำนวนเอกสาร</th>
                    <th style={thStyle}>ดูข้อมูล</th>
                  </tr>
                </thead>
                <tbody>
                  {dataprestatus.map((item, i) => (
                    <tr key={i} style={{ verticalAlign: 'middle' }}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={{ ...tdStyle, fontWeight: 500 }}>{item.approveby}</td>
                      <td style={tdStyle}>{item.departmentname}</td>
                      <td style={tdStyle}>
                        <Badge bg="secondary" style={{ fontSize: 11 }}>ลำดับที่ {item.stateflow}</Badge>
                      </td>
                      <td style={tdStyle}>
                        {item.total > 0 && (
                          <Badge bg="danger" style={{ fontSize: 11, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                            <BsExclamationCircleFill size={10} /> รอรับเอกสาร
                          </Badge>
                        )}
                      </td>
                      <td style={tdStyle}>
                        <Badge
                          bg={parseInt(item.total) > 5 ? 'danger' : parseInt(item.total) > 0 ? 'warning' : 'light'}
                          text={parseInt(item.total) === 0 ? 'dark' : undefined}
                          style={{ fontSize: 13, minWidth: 30 }}
                        >
                          {item.total}
                        </Badge>
                      </td>
                      <td style={tdStyle}>
                        <ShowDetailJournalById Id={item.emcode} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>

          {/* Received / In Progress Table */}
          <Card style={{ marginBottom: 20, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 10, overflow: 'hidden' }}>
            <SectionHeader
              icon={<BsClockHistory size={16} />}
              title={`รายการที่กำลังดำเนินการ (${dataJourReviewList.length} รายการ)`}
              color="#2980b9"
            />
            <Card.Body style={{ padding: 0 }}>
              <Table hover style={{ fontSize: 13, marginBottom: 0 }}>
                <thead>
                  <tr style={{ backgroundColor: '#eaf4fb' }}>
                    <th style={thStyle}>#</th>
                    <th style={thStyle}>TDS Code</th>
                    <th style={{ ...thStyle, width: 260 }}>ประเภทเอกสาร</th>
                    <th style={thStyle}>Job Status</th>
                    <th style={thStyle}>Confirm Job</th>
                    <th style={thStyle}>ระดับอนุมัติ</th>
                    <th style={thStyle}>ชื่อผู้รับ</th>
                    <th style={thStyle}>แผนก</th>
                    <th style={thStyle}>วันที่รับ</th>
                    <th style={thStyle}>เวลาที่ใช้ (วัน)</th>
                  </tr>
                </thead>
                <tbody>
                  {dataJourReviewList.map((item, i) => (
                    <tr key={i} style={{ verticalAlign: 'middle' }}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={{ ...tdStyle, fontWeight: 600, color: '#2c3e50' }}>{item.tdscode}</td>
                      <td style={tdStyle}>
                        <span style={{ fontSize: 12, color: '#555' }}>{item.NameForm}</span>
                      </td>
                      <td style={tdStyle}>
                        {item.statusprove_Tds == 1
                          ? <Badge bg="success" style={{ fontSize: 11 }}>Proof job</Badge>
                          : <Badge bg="light" text="secondary" style={{ fontSize: 11 }}>-</Badge>
                        }
                      </td>
                      <td style={tdStyle}>
                        {item.statusConfirm == 1
                          ? <Badge bg="success" style={{ fontSize: 11 }}>Approved</Badge>
                          : <Badge bg="light" text="secondary" style={{ fontSize: 11 }}>Pending</Badge>
                        }
                      </td>
                      <td style={tdStyle}>
                        <Badge bg="secondary" style={{ fontSize: 11 }}>ลำดับที่ {item.stateflow}</Badge>
                      </td>
                      <td style={tdStyle}>{item.empcode}</td>
                      <td style={tdStyle}>{item.departments}</td>
                      <td style={{ ...tdStyle, fontSize: 12, color: '#666' }}>{item.recievTime}</td>
                      <td style={{ ...tdStyle, fontWeight: 600 }}>
                        <Badge
                          bg={parseInt(item.sumdate) > 7 ? 'danger' : parseInt(item.sumdate) > 3 ? 'warning' : 'success'}
                          text={parseInt(item.sumdate) > 3 && parseInt(item.sumdate) <= 7 ? 'dark' : undefined}
                          style={{ fontSize: 12 }}
                        >
                          {item.sumdate} วัน
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>

        </div>
      )}
    </div>
  )
}

const statCardStyle = (bg, color) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  backgroundColor: bg,
  color: color,
  borderRadius: 10,
  padding: '14px 20px',
  minWidth: 160,
  flex: 1,
  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
});

const thStyle = {
  fontWeight: 600,
  fontSize: 12,
  color: '#444',
  padding: '10px 12px',
  borderBottom: '2px solid #dde',
  whiteSpace: 'nowrap',
};

const tdStyle = {
  padding: '10px 12px',
  borderBottom: '1px solid #f0f0f0',
  verticalAlign: 'middle',
};

export default Reportstatusjournalall
